export default __webpack_public_path__ + "static/media/eliminar_dir.323087e3.svg";